(() => {
  if(customElements.get('pg-gifts'))return;
  const el = (tag,text,className) => {const node=document.createElement(tag);if(text!=null)node.textContent=text;if(className)node.className=className;return node;};
  const money = cents => new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(cents/100);
  customElements.define('pg-gifts',class extends HTMLElement {
    connectedCallback(){if(!this.offer)this.hidden=true;}
    configure(offer,adapter){
      this.adapter=adapter;
      this.flow=window.petgrafGiftModel.flow(adapter,result=>this.update(result));
      this.update(offer);
    }
    update(offer){this.offer=offer;this.render();}
    render(){
      const offer=this.offer;
      this.hidden=!offer||offer.state==='inactive';
      this.replaceChildren();if(this.hidden)return;
      this.className='pg-gifts';
      this.append(el('h3','Um carinho para sua clínica'));
      const messages={progress:`Faltam ${money(offer.remaining||0)} para escolher seu presente.`,eligible:'Seu presente está liberado.',selected:'Seu presente vai junto com o pedido.',invalidated:'O carrinho mudou e o presente foi retirado. Confira o valor e escolha novamente quando estiver disponível.',unavailable:'Os presentes estão indisponíveis agora. Seus materiais continuam no carrinho.'};
      const status=el('p',messages[offer.state],'pg-gift-message');status.setAttribute('role','status');this.append(status);
      if(offer.threshold){const progress=el('progress');progress.max=offer.threshold;progress.value=offer.progress;progress.setAttribute('aria-label','Progresso para escolher um presente');this.append(progress);}
      const choices=el('div',null,'pg-gift-choices');
      for(const item of offer.choices||[]){
        const card=el('div',null,'pg-gift-choice');
        if(item.image){const image=el('img');image.src=item.image;image.alt=item.label;image.width=160;image.height=120;image.loading='lazy';card.append(image);}
        card.append(el('strong',item.label));
        const selected=offer.state==='selected'&&offer.selected===item.id;
        const canChoose = ['eligible','selected'].includes(offer.state) || (offer.state==='invalidated' && !offer.remaining);
        if(canChoose){
          const button=el('button',selected?'Escolhido':'Escolher este presente');button.type='button';button.setAttribute('aria-pressed',String(selected));button.disabled=selected;
          button.addEventListener('click',async()=>{
            this.querySelectorAll('button').forEach(node=>node.disabled=true);status.textContent='Conferindo seu presente…';
            try{await this.flow.choose(item.id);}catch(error){status.textContent=error.message||'Não foi possível confirmar o presente. Tente novamente.';this.querySelectorAll('button').forEach(node=>node.disabled=node.getAttribute('aria-pressed')==='true');}
          });card.append(button);
        }else card.append(el('span','Libera com R$ 300 em materiais','pg-gift-locked'));
        choices.append(card);
      }
      this.append(choices);
      if(offer.state==='selected')this.append(el('p','Personalizado com o Design do seu carrinho.','pg-gift-caption'));
      this.append(el('p','Escolha um presente por pedido. O valor elegível considera os materiais após descontos, sem frete e sem o próprio presente.','pg-gift-caption'));
    }
  });
  async function boot() {
    for (const node of document.querySelectorAll('pg-gifts[data-gift-enabled="true"]')) {
      if (node.dataset.configured) continue;
      node.dataset.configured = 'pending';
      const choices = [
        {id:node.dataset.a5Id,label:node.dataset.a5Label,image:node.dataset.a5Image,available:node.dataset.a5Available==='true' && !!node.dataset.a5Id},
        {id:node.dataset.certificateId,label:node.dataset.certificateLabel,image:node.dataset.certificateImage,available:node.dataset.certificateAvailable==='true' && !!node.dataset.certificateId}
      ];
      const cart = async (path='', options) => {
        const endpoint = path ? '/cart' + path : '/cart.js';
        const response = await fetch(endpoint,{...options,headers:{Accept:'application/json','Content-Type':'application/json'},cache:'no-store'});
        if (!response.ok) throw new Error('Não foi possível atualizar o presente agora. Tente novamente.');
        return response.json();
      };
      const gifts = value => value.items.filter(item => item.properties?._pg_gift === 'petgraf-clinic-care');
      const eligibility = async value => {
        const subtotal = value.items.filter(item => !item.properties?._pg_gift).reduce((sum,item)=>sum+Number(item.final_line_price||0),0);
        const available = choices.filter(item=>item.available).map(item=>({variant_id:item.id}));
        const eligible = subtotal >= 30000;
        return eligible ? {state:'eligible',choices:available} : {state:'progress',remaining:30000-subtotal,choices:available};
      };
      const renderOffer = async value => {
        const unsafe = gifts(value).filter(item=>Number(item.final_line_price||0)!==0);
        if (unsafe.length) {
          for (const gift of unsafe) await cart('/change.js',{method:'POST',body:JSON.stringify({id:gift.key,quantity:0})});
          value = await cart();
        }
        const selected = gifts(value).find(item=>Number(item.final_line_price||0)===0)?.variant_id?.toString() || null;
        const subtotal = value.items.filter(item=>!item.properties?._pg_gift).reduce((sum,item)=>sum+Number(item.final_line_price||0),0);
        return window.petgrafGiftModel.offer({active:true,verified:true,threshold:30000,eligibleSubtotal:subtotal,selected,choices,invalidated:unsafe.length>0});
      };
      const adapter = {
        async choose(id) {
          let value = await cart(); const decision = await eligibility(value);
          if (decision.state !== 'eligible') throw new Error('O presente só pode ser escolhido a partir de R$ 300 em materiais.');
          const design = window.petgrafDesign?.current;
          if (!design?.saved) throw new Error('Salve o Design do carrinho antes de escolher o presente.');
          for (const gift of gifts(value)) await cart('/change.js',{method:'POST',body:JSON.stringify({id:gift.key,quantity:0})});
          await cart('/add.js',{method:'POST',body:JSON.stringify({items:[{id:Number(id),quantity:1,properties:{_pg_gift:'petgraf-clinic-care',_pg_design_id:design.id,_pg_design_revision:String(design.revision)}}]})});
          value = await cart(); const selected = gifts(value).find(item=>String(item.variant_id)===String(id));
          if (!selected || Number(selected.final_line_price)!==0) {
            if (selected) await cart('/change.js',{method:'POST',body:JSON.stringify({id:selected.key,quantity:0})});
            throw new Error('O desconto do presente não foi confirmado. Ele foi retirado para não ser cobrado.');
          }
          await window.petgrafCart?.refresh();
          return renderOffer(value);
        }
      };
      try {
        node.configure(await renderOffer({items:[]}),adapter);node.dataset.configured='true';
      } catch {
        delete node.dataset.configured;
        continue;
      }
      cart().then(async value=>node.update(await renderOffer(value))).catch(()=>{});
    }
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  new MutationObserver(boot).observe(document.body,{childList:true,subtree:true});
})();
